var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPagePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_183045",
    "data-name": "Group 183045",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 539.859,
    height: 348.637,
    viewBox: "0 0 539.859 348.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.813,
    y1: 0.482,
    x2: -1.087,
    y2: 0.592,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.645,
    y1: 0.17,
    x2: 0.056,
    y2: 1.638,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2.625,
    y1: -0.3,
    x2: 0.872,
    y2: 0.357,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2.005,
    y1: -1.463,
    x2: 1.245,
    y2: -0.452,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 63.701,
    y1: -5.593,
    x2: 62.498,
    y2: 0.571,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 45.755,
    y1: -14.746,
    x2: 44.895,
    y2: -0.838,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1.683,
    y1: -1.523,
    x2: 1.096,
    y2: -0.535,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.984,
    y1: 1.606,
    x2: 0.115,
    y2: 0.216,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 23.463,
    y1: -0.039,
    x2: 25.199,
    y2: 1.172,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 72.004,
    y1: 0.5,
    x2: 73.004,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2.543,
    y1: -4.534,
    x2: 1.587,
    y2: -2.185,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3.82,
    y1: -2.503,
    x2: 0.957,
    y2: 0.086,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1.036,
    y1: 1,
    x2: -0.035,
    y2: 0,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.517,
    y1: 0.711,
    x2: 0.082,
    y2: 3.578,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 4.496,
    y1: -1.203,
    x2: 1.68,
    y2: 0.021,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.456,
    y1: -0.478,
    x2: 0.582,
    y2: 2.178,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.459,
    y1: -0.411,
    x2: 0.577,
    y2: 2.089,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.614,
    y1: 0.775,
    x2: 0.164,
    y2: -0.275,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 2.583,
    y1: -5.428,
    x2: 1.282,
    y2: -1.749,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.519,
    y1: 2.65,
    x2: 0.467,
    y2: -3.051,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.642,
    y1: 1.482,
    x2: 0.492,
    y2: 0.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.853,
    y1: 0.905,
    x2: 2.585,
    y2: 3.246,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.094,
    y1: 0.218,
    x2: 0.929,
    y2: 1.314,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.145,
    y1: 4.1,
    x2: 0.81,
    y2: -2.839,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.475,
    y1: 1.119,
    x2: 0.36,
    y2: 4.357,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.683,
    y1: 0.746,
    x2: 0.381,
    y2: -0.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.801,
    y1: -0.117,
    x2: 0.414,
    y2: 1.176,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -0.361,
    y1: 0.702,
    x2: 5.684,
    y2: -0.391,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -1.038,
    y1: 0.979,
    x2: 2.545,
    y2: -0.116,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 2.314,
    y1: -1.081,
    x2: 1.538,
    y2: -0.466,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 3.085,
    y1: -1.029,
    x2: 2.1,
    y2: -0.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 2.648,
    y1: -5.407,
    x2: -0.78,
    y2: 4.022,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.332,
    y1: -0.565,
    x2: 0.664,
    y2: 1.262,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -36.493,
    y1: 0.5,
    x2: -35.493,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -46.32,
    y1: 0.5,
    x2: -45.32,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -44.543,
    y1: -12.945,
    x2: -48.242,
    y2: 11.133,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -123.699,
    y1: -0.843,
    x2: -124.206,
    y2: 2.39,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -28.499,
    y1: -5.387,
    x2: -31.015,
    y2: 17.678,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -29.758,
    y1: 0.5,
    x2: -28.758,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -117.248,
    y1: -0.223,
    x2: -117.763,
    y2: 2.539,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0.536,
    y1: 0.357,
    x2: 0.412,
    y2: 0.965,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -15.649,
    y1: 0.075,
    x2: -15.883,
    y2: 2.222,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -51.232,
    y1: -0.222,
    x2: -52.05,
    y2: 2.966,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -74.38,
    y1: -44.622,
    x2: -75.452,
    y2: -43.34,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -53.128,
    y1: -29.143,
    x2: -52.221,
    y2: -29.143,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -219.044,
    y1: -147.047,
    x2: -216.586,
    y2: -149.696,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 33.836,
    y1: -1.878,
    x2: 6.317,
    y2: 0.085,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -0.987,
    y1: -14.54,
    x2: 0.144,
    y2: -3.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -18.534,
    y1: 0.24,
    x2: -18.851,
    y2: 5.364,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -40.846,
    y1: -1.461,
    x2: -44.079,
    y2: 3.372,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -39.421,
    y1: -1.014,
    x2: -42.63,
    y2: 5.177,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0.94,
    y1: -0.484,
    x2: -1.895,
    y2: 6.012,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 4.065,
    y1: -0.489,
    x2: 1.167,
    y2: 0.315,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 3.08,
    y1: -2.223,
    x2: -3.938,
    y2: 5.384,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 2.979,
    y1: -0.547,
    x2: 0.937,
    y2: 0.243,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -0.138,
    y1: 0.775,
    x2: 1.475,
    y2: -0.237,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 297.31,
    y1: 1.605,
    x2: 299.31,
    y2: 4.278,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1.863,
    y1: -3.263,
    x2: 0.458,
    y2: 0.493,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -0.241,
    y1: 1.066,
    x2: 3.808,
    y2: -1.521,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1.546,
    y1: -2.889,
    x2: 1.007,
    y2: -1.195,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 0.469,
    y1: 0.726,
    x2: 0.94,
    y2: -1.396,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -129.355,
    y1: 6.185,
    x2: -129.229,
    y2: 4.445,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -94.95,
    y1: -43.496,
    x2: -94.745,
    y2: -42.317,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -422.816,
    y1: 27.428,
    x2: -422.406,
    y2: 18.994,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 2.957,
    y1: -0.319,
    x2: 0.622,
    y2: 0.45,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 0.042,
    y1: 1.014,
    x2: 1.319,
    y2: -0.18,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 0.512,
    y1: 0.489,
    x2: -4.839,
    y2: 1.62,
    xlinkHref: "#linear-gradient-3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61768",
    "data-name": "Path 61768",
    d: "M215.515,106.911c-41.875,34.608,14.1,79.032-14.9,98.425s-149.1,57.215-28.155,132.248,127.068,111.47,213.41,63.961,77.344-42.766,148.4-10.648,145.318-17.852,120.068-77.157S613.01,255.174,641.842,217.3,613.333,79.32,496.319,131.457c-54.906,24.464-113.188,31.224-124.086.933S281.692,52.218,215.515,106.911Z",
    transform: "translate(-119.516 -82.459)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_183007",
    "data-name": "Group 183007",
    transform: "translate(238.131 84.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61769",
    "data-name": "Path 61769",
    d: "M1146.639,430.916c14.821,23.451,95.5,163.445-22.271,262.747,0,0-76.838-78.49,18.2-262.577A2.347,2.347,0,0,1,1146.639,430.916Z",
    transform: "translate(-1095.034 -429.821)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61770",
    "data-name": "Path 61770",
    d: "M1295.377,547.062s2.208,13.116,4.735,32.9c.634,4.945,1.285,10.306,1.932,15.982s1.294,11.665,1.887,17.869c.616,6.2,1.169,12.618,1.7,19.142q.36,4.9.725,9.855c.2,3.305.443,6.621.616,9.942s.375,6.639.5,9.949q.105,2.482.21,4.952.079,2.471.158,4.926t.144,4.887q.041,2.433.082,4.841c.073,3.208.07,6.379.075,9.5.006,6.238-.111,12.269-.318,17.986s-.515,11.12-.92,16.1c-.161,2.493-.419,4.875-.647,7.141l-.333,3.311c-.121,1.072-.269,2.11-.4,3.118-.273,2.014-.483,3.9-.758,5.642l-.782,4.773-.34,2.043q-.194.957-.364,1.792l-.575,2.826-.479,2.353a.99.99,0,0,1-1.94-.4v-.005l.009-.041.486-2.324.584-2.791.37-1.77.347-2.022.8-4.725c.282-1.721.5-3.6.782-5.594.131-1,.284-2.029.41-3.094l.349-3.288c.239-2.251.508-4.616.682-7.1.429-4.951.758-10.328,1-16.021s.386-11.7.413-17.923c.011-3.11.032-6.272-.024-9.473q-.028-2.4-.056-4.829-.059-2.427-.118-4.877t-.131-4.916q-.092-2.465-.183-4.944c-.106-3.3-.291-6.619-.445-9.934s-.377-6.628-.562-9.929q-.337-4.948-.671-9.845c-.491-6.517-1.009-12.929-1.591-19.127-.56-6.2-1.183-12.186-1.79-17.861s-1.237-11.034-1.844-15.977c-2.419-19.777-4.553-32.887-4.553-32.887a.419.419,0,0,1,.828-.136Z",
    transform: "translate(-1245.842 -518.178)",
    fill: "#fff",
    opacity: 0.86
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183008",
    "data-name": "Group 183008",
    transform: "translate(270.085 25.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61771",
    "data-name": "Path 61771",
    d: "M1433.827,186.029a3.332,3.332,0,0,1,5.152,2.624c2,39.334,4.284,268.713-210.575,309.52C1228.4,498.173,1188.026,347.552,1433.827,186.029Z",
    transform: "translate(-1225.934 -185.479)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61772",
    "data-name": "Path 61772",
    d: "M1483.014,331.383s-5.7,19.079-16.606,46.844c-5.451,13.878-12.188,29.928-20.1,46.81-7.888,16.89-16.979,34.6-26.933,51.824a499.212,499.212,0,0,1-32.038,48.855c-5.6,7.464-11.276,14.488-16.9,20.944s-11.177,12.352-16.521,17.58-10.469,9.789-15.129,13.69l-3.413,2.794c-1.1.9-2.2,1.713-3.237,2.524-2.063,1.634-4.039,3.028-5.8,4.317l-1.289.937-1.243.847-2.258,1.539c-1.391.972-2.617,1.734-3.605,2.362l-3.029,1.926a.99.99,0,0,1-1.062-1.671l0,0,.028-.017,3-1.895c.98-.618,2.2-1.367,3.576-2.325l2.241-1.516,1.234-.834,1.28-.924c1.75-1.27,3.713-2.644,5.764-4.256,1.03-.8,2.122-1.606,3.218-2.49l3.4-2.758c4.637-3.853,9.738-8.363,15.067-13.536s10.873-11.017,16.488-17.419,11.288-13.375,16.894-20.789a497.637,497.637,0,0,0,32.113-48.59c9.992-17.148,19.13-34.792,27.066-51.627,7.958-16.827,14.743-32.832,20.238-46.673s9.687-25.529,12.5-33.746,4.248-12.967,4.248-12.967a.419.419,0,0,1,.8.242Z",
    transform: "translate(-1292.046 -295.359)",
    fill: "#fff",
    opacity: 0.86
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183009",
    "data-name": "Group 183009",
    transform: "translate(274.435 198.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61773",
    "data-name": "Path 61773",
    d: "M1494.423,895.91a2.565,2.565,0,0,1,2.6,3.613c-12.51,27.615-91.878,185.344-253.266,137.453C1243.755,1036.976,1269.275,919.686,1494.423,895.91Z",
    transform: "translate(-1243.755 -895.895)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61774",
    "data-name": "Path 61774",
    d: "M1544.441,968.99s-2.634,2.673-7.383,7.19c-2.382,2.251-5.278,4.982-8.657,8.052s-7.214,6.508-11.442,10.208c-4.248,3.677-8.862,7.648-13.837,11.735-4.951,4.116-10.265,8.343-15.793,12.678-5.566,4.285-11.344,8.681-17.335,12.985l-4.5,3.247-4.584,3.193c-3.047,2.156-6.175,4.221-9.286,6.312-.78.519-1.552,1.05-2.339,1.559l-2.362,1.521-4.717,3.037c-3.16,1.989-6.338,3.922-9.483,5.853l-4.757,2.786-2.361,1.383c-.782.465-1.569.917-2.364,1.349l-4.717,2.615c-1.561.866-3.107,1.735-4.675,2.531-6.215,3.292-12.31,6.313-18.174,9l-4.352,1.953-2.128.955c-.7.32-1.419.59-2.119.884-2.814,1.139-5.514,2.287-8.141,3.3l-7.589,2.788-.9.328-.9.29-1.761.568-3.372,1.088-3.164,1.018-2.983.82-5.255,1.444c-.789.233-1.552.394-2.267.554l-2.01.45-3.17.71-2.639.591a.99.99,0,1,1-.432-1.932h0l.05-.011,2.614-.572,3.14-.687,1.991-.436c.709-.154,1.464-.31,2.247-.537l5.213-1.407,2.96-.8,3.142-.995,3.35-1.063,1.75-.555.893-.283.894-.321,7.548-2.732c2.614-1,5.3-2.124,8.105-3.242.7-.289,1.411-.553,2.11-.868l2.12-.94,4.337-1.922c5.845-2.644,11.925-5.622,18.129-8.871,1.565-.785,3.108-1.643,4.667-2.5l4.711-2.582c.794-.427,1.58-.873,2.361-1.333l2.359-1.367,4.753-2.754c3.143-1.91,6.321-3.822,9.481-5.79l4.717-3.005,2.363-1.505c.786-.5,1.559-1.03,2.34-1.544,3.112-2.071,6.242-4.115,9.292-6.252l4.588-3.164,4.51-3.218c6-4.266,11.786-8.626,17.362-12.877,5.538-4.3,10.864-8.495,15.826-12.581,4.987-4.057,9.613-8,13.872-11.651,4.239-3.675,8.1-7.075,11.474-10.138s6.292-5.762,8.681-8c4.765-4.489,7.4-7.136,7.4-7.136a.42.42,0,1,1,.595.592Z",
    transform: "translate(-1317.803 -950.606)",
    fill: "#dce5fe"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183010",
    "data-name": "Group 183010",
    transform: "translate(91.586 213.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61775",
    "data-name": "Path 61775",
    d: "M651.394,1082.156s-11.131-88.467-65.022-104.914c-51.7-15.777-59.739,9.7-88.235-19.84a2,2,0,0,0-3.428,1.537c1.624,20.031,11.431,86.958,70.025,88.176C632.439,1048.522,651.394,1082.156,651.394,1082.156Z",
    transform: "translate(-494.702 -956.784)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61776",
    "data-name": "Path 61776",
    d: "M544.2,1035.714l.059.111.177.315c.159.282.416.7.764,1.226a41.218,41.218,0,0,0,3.39,4.353,57.987,57.987,0,0,0,6.187,5.961,71.98,71.98,0,0,0,9.095,6.452,92.971,92.971,0,0,0,11.77,5.98,115.341,115.341,0,0,0,13.925,4.848,147.076,147.076,0,0,0,15.407,3.4l8.057,1.317,4.076.8,4.048.923a112.135,112.135,0,0,1,15.758,5.049,87.124,87.124,0,0,1,14.271,7.423c2.211,1.4,4.277,2.946,6.27,4.492,1.951,1.6,3.831,3.2,5.544,4.89a83.979,83.979,0,0,1,8.926,10.154c2.512,3.348,4.6,6.562,6.359,9.45s3.2,5.453,4.372,7.565l3.624,6.642a1.714,1.714,0,0,1-3.009,1.642l-.008-.015-.006-.011L679.749,1122c-1.128-2.109-2.511-4.656-4.191-7.511s-3.667-6.013-6.051-9.294a81.067,81.067,0,0,0-8.474-9.94c-1.627-1.653-3.417-3.225-5.275-4.8-1.9-1.52-3.874-3.042-5.992-4.431a84.644,84.644,0,0,0-13.755-7.419,109.871,109.871,0,0,0-15.365-5.178l-3.969-.968-3.98-.842-8.039-1.44a148.851,148.851,0,0,1-15.536-3.678,116.878,116.878,0,0,1-14.029-5.123,94.241,94.241,0,0,1-11.84-6.243,73.042,73.042,0,0,1-9.13-6.687,58.931,58.931,0,0,1-6.2-6.153,42.068,42.068,0,0,1-3.394-4.5c-.35-.552-.607-.981-.771-1.281l-.187-.345-.059-.116a.384.384,0,0,1,.681-.354Z",
    transform: "translate(-531.57 -1016.287)",
    fill: "#fff",
    opacity: 0.69
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183011",
    "data-name": "Group 183011",
    transform: "translate(79.245 67.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61777",
    "data-name": "Path 61777",
    d: "M621.281,627.405l-6.946-2.337c-7.131-48.6-34.688-134.783-87.718-148.532-35.92-9.313-51.86-24.849-57.717-64.07-3.907-26.165-16.285-42.18-24.093-49.942a2.2,2.2,0,0,1,2.086-3.69c21.865,5.527,79.565,23.371,112.951,64.218C601.635,474.187,621.281,627.405,621.281,627.405Z",
    transform: "translate(-444.146 -358.762)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61778",
    "data-name": "Path 61778",
    d: "M604.911,465.6a.809.809,0,0,1,.469-1.548l.188.056c.124.035.311.092.565.182l.938.32,1.248.483c.952.346,2.072.875,3.409,1.461.671.289,1.356.664,2.107,1.029.74.383,1.553.746,2.364,1.212l2.578,1.444c.447.258.92.5,1.376.788l1.4.877,2.981,1.863c1.007.68,2.035,1.408,3.105,2.146a157.349,157.349,0,0,1,13.7,10.815c.62.506,1.2,1.066,1.8,1.625l1.8,1.69,3.705,3.477L652.3,497.3l1.869,1.932.945.977.475.491.452.515,3.673,4.178,1.871,2.129c.626.715,1.271,1.422,1.856,2.184l3.636,4.55,1.845,2.309c.61.779,1.26,1.534,1.829,2.354l7.141,9.838,6.86,10.393c4.507,7.049,8.747,14.466,12.7,22s7.626,15.225,10.973,22.9,6.419,15.331,9.2,22.808c5.563,14.953,9.962,29.188,13.338,41.492s5.764,22.675,7.284,29.968c.762,3.647,1.314,6.524,1.676,8.492l.4,2.253.133.785a1.714,1.714,0,0,1-3.38.57l0-.011,0-.025-.122-.751-.381-2.218c-.344-1.945-.871-4.8-1.6-8.42-1.459-7.245-3.758-17.566-7.038-29.819s-7.554-26.435-12.983-41.331c-2.711-7.448-5.7-15.075-8.986-22.721s-6.868-15.3-10.743-22.812S687.2,547.453,682.763,540.4l-6.741-10.363L669,520.233c-.56-.818-1.2-1.57-1.8-2.346l-1.814-2.3-3.575-4.536c-.575-.761-1.21-1.464-1.825-2.177l-1.84-2.122-3.613-4.166-.445-.513-.467-.489-.929-.973-1.839-1.926-3.593-3.764-3.644-3.464-1.772-1.685c-.585-.557-1.157-1.115-1.767-1.619a155.537,155.537,0,0,0-13.464-10.775c-1.051-.736-2.06-1.461-3.049-2.139l-2.924-1.854-1.377-.874c-.448-.288-.91-.527-1.348-.784L615.4,470.29c-.8-.464-1.587-.823-2.311-1.2-.733-.362-1.4-.737-2.057-1.022-1.3-.579-2.394-1.106-3.31-1.445l-1.2-.475-.867-.3c-.229-.084-.414-.142-.541-.179l-.188-.058Z",
    transform: "translate(-565.235 -438.326)",
    fill: "#fff",
    opacity: 0.69
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183012",
    "data-name": "Group 183012",
    transform: "translate(227.865 37.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61779",
    "data-name": "Path 61779",
    d: "M1090.472,887.043l4.911,137.52a2.12,2.12,0,0,1-1.675,2.149l-39.055,8.369a2.121,2.121,0,0,0-1.452,1.125h0a2.12,2.12,0,0,0,1.9,3.068h87.977a2.12,2.12,0,0,0,2.12-2.12v-.129a2.121,2.121,0,0,0-1.7-2.077l-40.376-8.259a2.12,2.12,0,0,1-1.7-2.093l.983-137.553h-11.94Z",
    transform: "translate(-1052.976 -727.937)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61780",
    "data-name": "Path 61780",
    d: "M1098.4,237.363v.032a2.105,2.105,0,0,1-1.724,2.071l-15.589,2.875a2.105,2.105,0,0,0-1.647,1.508l-7.321,26.415a25.33,25.33,0,0,0-.473,11.5l9.781,51.348a12.557,12.557,0,0,1-2.046,9.556c-5.467,7.814-15.95,26.376-12.657,50.209a7.632,7.632,0,0,0,5.066,6.176c10.014,3.446,36.688,10.225,70.572-.143a7.624,7.624,0,0,0,5.352-6.941c.406-8.458-.517-26.328-11.6-49.508a12.664,12.664,0,0,1-.983-8.1l10.677-50.1a25.33,25.33,0,0,0-.494-12.5l-8.69-29.232a2.105,2.105,0,0,0-1.868-1.5l-10.521-.752a2.105,2.105,0,0,1-1.955-2.1h0a2.105,2.105,0,0,0-2.018-2.1l-19.668-.819A2.105,2.105,0,0,0,1098.4,237.363Z",
    transform: "translate(-1062.895 -235.257)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61781",
    "data-name": "Path 61781",
    d: "M1096.583,243.439s5.97-5.97,9.95-2.985,15.919,33.829,34.824,43.779,48.754-.995,70.643-9.95,73.628,47.759,83.578,96.513c7.243,35.49,6.577,68.872,5.679,84.408a13.112,13.112,0,0,1-9.911,11.995c-7.925,1.962-19.625,3.629-29.6.11a37.082,37.082,0,0,0-9.189-2.145,13.087,13.087,0,0,1-11.917-12.111l-11.531-155.229a5.1,5.1,0,0,0-4.559-4.781c-1.81-.139-3.881.714-5.587,4.125-3.98,7.96-20.894,48.754-57.708,50.744s-69.648-41.789-72.633-46.764a8.915,8.915,0,0,1,.367-9.517l1.079,5.665S1110.512,295.177,1096.583,243.439Z",
    transform: "translate(-1078.986 -238.554)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61782",
    "data-name": "Path 61782",
    d: "M1782.893,516.685c5.97,13.93,13.691,26.715,16.676,55.57,2.289,22.129-1.563,75.011-.347,98.855,8.182,1.684,16.946.577,23.585-.925-1.487-20.489-4.759-62.027-9.069-95.791C1807.767,527.63,1776.923,502.756,1782.893,516.685Z",
    transform: "translate(-1604.138 -445.073)",
    fill: "url(#linear-gradient-5)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183013",
    "data-name": "Group 183013",
    transform: "translate(366.328 82.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61783",
    "data-name": "Path 61783",
    d: "M1759.4,743.67s9.8,21.366,14.946,30.216c0,0,1.022,5.569,0,7.32l-.87.387,4.063-.121s.361-7.49.079-7.909a1.035,1.035,0,0,0-.846-.391s-1.742-13.8-6.788-16.748l-4.89-16.841Z",
    transform: "translate(-1725.42 -661.781)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61784",
    "data-name": "Path 61784",
    d: "M1809.954,886.53c-.006.1,3.173.053,4.9.022a1.373,1.373,0,0,0,1.317-1.083l1.3-6.851a1.232,1.232,0,0,0-.936-1.431l-.728-.167a3.9,3.9,0,0,0-.712,2.766c.327,1.341.618,4.815-.208,5.219a12.06,12.06,0,0,1-3.2.476S1810.008,885.647,1809.954,886.53Z",
    transform: "translate(-1763.633 -765.669)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61785",
    "data-name": "Path 61785",
    d: "M1720.773,905.428a.359.359,0,0,0,.181.67c2.89-.029,9.365-.121,9.94-.36.743-.309-.271-2.978-1.338-3.882l-5.89,1.922Z",
    transform: "translate(-1696.085 -784.444)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61786",
    "data-name": "Path 61786",
    d: "M1713.846,750.746s6.335,30.646,8.127,36.625l-4.239,2.66s2.125-.361,3.7-.476,3.025-1.922,3.025-1.922l-.508-.81s-1.589-30.48-1.2-33.941Z",
    transform: "translate(-1690.986 -670.22)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61787",
    "data-name": "Path 61787",
    d: "M1627.333,429.909s-.874,15.942,13.641,24.089l-3.494,7.97s-13.141-7.948-12.655-29.626a2.52,2.52,0,0,0-.617-1.7l-2.793-3.24a5.014,5.014,0,0,1-1.066-4.49l.368-1.47a.762.762,0,0,1,1.122-.474l.292.17a5.128,5.128,0,0,1,2.105,2.34l1.4,2.213c.512,1.145.632,1.626,1.882,1.518l2.324.026Z",
    transform: "translate(-1620.199 -420.866)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61788",
    "data-name": "Path 61788",
    d: "M1692.39,551.609c2.428.673,10.655,2.837,15.79,2.749l-3.153,17.794.251,2.9L1695,575.008a79.727,79.727,0,0,0-5.177-10.072c-.66-.968-.169-2.122.2-3.232l-.514-.342a1.4,1.4,0,0,1-.554-1.6l2.5-7.66A.765.765,0,0,1,1692.39,551.609Z",
    transform: "translate(-1672.12 -519.673)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61789",
    "data-name": "Path 61789",
    d: "M1708.23,640.227l.2,1.758s-2.905,8.7,1.453,29.022c0,0,9.438,2.674,17.2-3.724,0,0-2.188-19.18-2.786-20.074-2.977-4.45-4.96-5.417-4.96-5.417l-.089-1.921S1710.948,641.371,1708.23,640.227Z",
    transform: "translate(-1686.177 -586.41)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61790",
    "data-name": "Path 61790",
    d: "M1727.026,537.168c-.036-.048,2.146-6.589,2.146-6.589l3.126.284,1.221,7.421S1728.62,539.272,1727.026,537.168Z",
    transform: "translate(-1700.948 -503.797)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61791",
    "data-name": "Path 61791",
    d: "M1728.574,487.333c-.208.13-6.68,2.8-5.29,9.523a1.261,1.261,0,0,0,.717.9,10.965,10.965,0,0,0,5.439.9c3.39-.344,5.612-6.26,5.517-7.982S1730.64,486.046,1728.574,487.333Z",
    transform: "translate(-1697.973 -470.866)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61792",
    "data-name": "Path 61792",
    d: "M1733.6,477.138c-.17.022-3.74,1.266-1.97,3.852s2.434,4.109,1.6,5.245c-.763,1.035-2.453.445-2.305,2.6a1.208,1.208,0,0,1-.515,1.091c-1.592,1.078-5.477,4.4-1.628,9.127a1.2,1.2,0,0,1,.136,1.348c-1.127,2.022-3.5,7.946,5.078,11.232,8.471,3.247,11.53-2.291,12.385-4.5a1.182,1.182,0,0,1,1.169-.748c.931.044,2.25-.111,2.189-1.355a3.108,3.108,0,0,0-1.066-1.976,1.18,1.18,0,0,1,.227-1.858,2.311,2.311,0,0,0,1.142-1.436c.513-1.9-.511-7.591-5.964-8.555a1.287,1.287,0,0,1-1-.964l0-.021a1.179,1.179,0,0,1,.438-1.159,3.06,3.06,0,0,0,1.08-3.987,4.468,4.468,0,0,0-3.493-2.642,1.188,1.188,0,0,1-.973-1.419C1740.509,479.19,1740.172,476.276,1733.6,477.138Z",
    transform: "translate(-1701.025 -463.284)",
    fill: "url(#linear-gradient-14)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183027",
    "data-name": "Group 183027",
    transform: "translate(60.282 155.819)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149843",
    "data-name": "Rectangle 149843",
    width: 161.189,
    height: 3.655,
    transform: "translate(27.23 160.287)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61793",
    "data-name": "Path 61793",
    d: "M630.272,918.5l-4.012-.262c1.833-28.116-1.5-127.041-2.567-156.691a8.043,8.043,0,0,0-7.992-7.707h-.109L474.3,755.769a6.831,6.831,0,0,0-6.72,7.285c2.345,35.772,1.515,154.14,1.507,155.331l-4.021-.029c.009-1.19.837-119.412-1.5-155.039a10.852,10.852,0,0,1,10.677-11.568l141.293-1.927A12.079,12.079,0,0,1,627.712,761.4C628.779,791.1,632.118,890.2,630.272,918.5Z",
    transform: "translate(-439.847 -742.732)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183016",
    "data-name": "Group 183016",
    transform: "translate(0 174.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61794",
    "data-name": "Path 61794",
    d: "M374.034,1448.222l-1.473-5.4a4.825,4.825,0,0,1,4.531-6.092l46.133-1.183a4.375,4.375,0,0,1,4.481,4.61l-.425,7.86a.985.985,0,0,1-.984.932h-.64a.985.985,0,0,1-.985-.985v-6.928a2.569,2.569,0,0,0-2.683-2.567l-43.982,1.955a2.569,2.569,0,0,0-2.446,2.789l.406,4.665a.985.985,0,0,1-.982,1.071h0A.985.985,0,0,1,374.034,1448.222Z",
    transform: "translate(-370.942 -1435.544)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183014",
    "data-name": "Group 183014",
    transform: "translate(0 9.383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1836",
    "data-name": "Ellipse 1836",
    cx: 4.386,
    cy: 4.386,
    r: 4.386,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61795",
    "data-name": "Path 61795",
    d: "M377.571,1484.03a2.559,2.559,0,1,1-2.559-2.558A2.559,2.559,0,0,1,377.571,1484.03Z",
    transform: "translate(-370.992 -1479.643)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183015",
    "data-name": "Group 183015",
    transform: "translate(51.171 9.383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1837",
    "data-name": "Ellipse 1837",
    cx: 4.386,
    cy: 4.386,
    r: 4.386,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61796",
    "data-name": "Path 61796",
    d: "M587.2,1484.03a2.559,2.559,0,1,1-2.558-2.558A2.558,2.558,0,0,1,587.2,1484.03Z",
    transform: "translate(-580.618 -1479.643)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_183019",
    "data-name": "Group 183019",
    transform: "translate(159.179 174.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61797",
    "data-name": "Path 61797",
    d: "M1026.118,1448.971l-1.473-5.4a4.824,4.824,0,0,1,4.531-6.092l46.133-1.183a4.376,4.376,0,0,1,4.481,4.61l-.425,7.86a.985.985,0,0,1-.984.932h-.64a.985.985,0,0,1-.985-.985v-6.928a2.569,2.569,0,0,0-2.683-2.567l-43.982,1.955a2.57,2.57,0,0,0-2.446,2.789l.406,4.665a.986.986,0,0,1-.982,1.071h0A.985.985,0,0,1,1026.118,1448.971Z",
    transform: "translate(-1023.026 -1436.293)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183017",
    "data-name": "Group 183017",
    transform: "translate(0 9.383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1838",
    "data-name": "Ellipse 1838",
    cx: 4.386,
    cy: 4.386,
    r: 4.386,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61798",
    "data-name": "Path 61798",
    d: "M1029.656,1484.777a2.558,2.558,0,1,1-2.558-2.558A2.559,2.559,0,0,1,1029.656,1484.777Z",
    transform: "translate(-1023.077 -1480.391)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183018",
    "data-name": "Group 183018",
    transform: "translate(51.171 9.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61799",
    "data-name": "Path 61799",
    d: "M1236.946,1479.118a4.386,4.386,0,1,1-4.386-4.386A4.386,4.386,0,0,1,1236.946,1479.118Z",
    transform: "translate(-1228.174 -1474.732)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61800",
    "data-name": "Path 61800",
    d: "M1239.281,1484.777a2.558,2.558,0,1,1-2.558-2.558A2.558,2.558,0,0,1,1239.281,1484.777Z",
    transform: "translate(-1232.702 -1480.391)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149844",
    "data-name": "Rectangle 149844",
    width: 1.097,
    height: 13.158,
    transform: "translate(74.015 10.064)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183020",
    "data-name": "Group 183020",
    transform: "translate(58.339 17.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61801",
    "data-name": "Path 61801",
    d: "M610.714,1039.51s17.544-3.29,31.068-1.462c0,0,5.852,22.432,8.395,33.64a4.76,4.76,0,0,1-4.36,5.808c-8.827.52-26.188,1.429-35.734,1.161a4.758,4.758,0,0,1-4.587-5.365C606.7,1063.936,609.332,1044.207,610.714,1039.51Z",
    transform: "translate(-605.455 -977.739)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61802",
    "data-name": "Path 61802",
    d: "M670.529,869.275a1.279,1.279,0,0,1-1.272-1.156c-.017-.174-1.714-17.586-3.968-35.286-3.435-26.976-5.614-34.705-6.622-36.906-.74,2.277-1.96,10.114-1.983,36.965-.015,17.624.5,34.892.5,35.064a1.279,1.279,0,1,1-2.557.077c-.006-.182-.548-18.412-.5-36.563.027-10.676.249-19.241.66-25.459.768-11.614,2.022-12.9,3.349-13.252a1.81,1.81,0,0,1,1.517.287c1.028.712,3.436,2.38,8.124,39.072,2.284,17.875,4.009,35.576,4.026,35.753a1.279,1.279,0,0,1-1.15,1.4C670.613,869.273,670.571,869.275,670.529,869.275Z",
    transform: "translate(-642.245 -792.701)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61803",
    "data-name": "Path 61803",
    d: "M652.453,1062.22h4.021l.334,10.683a.983.983,0,0,1-.982,1.014h-2.054a.983.983,0,0,1-.983-.952Z",
    transform: "translate(-640.98 -996.428)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61804",
    "data-name": "Path 61804",
    d: "M709.352,1059.225h3.655l1,11.358a.983.983,0,0,1-.979,1.069h-1.681a.983.983,0,0,1-.979-.9Z",
    transform: "translate(-683.99 -994.165)",
    fill: "url(#linear-gradient-23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183021",
    "data-name": "Group 183021",
    transform: "translate(9.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61805",
    "data-name": "Path 61805",
    d: "M416.484,745.647a72.69,72.69,0,0,1-3.575-8.3,9.981,9.981,0,0,1,3.143-11.138,56.371,56.371,0,0,1,5.371-3.845,10.377,10.377,0,0,1,12.638,1.263c2,1.9,4.156,3.875,5.451,4.847,0,0,20.134,0,30.219-5.977a1.451,1.451,0,0,1,2.183,1.253c.009,3.668-1.21,10.476-9.375,15.324-11.7,6.945-20.834,14.255-26.316,22.3-5.154,7.56-22.584,17.38-31.638,14.278a1.452,1.452,0,0,1-.73-2.153C409.564,764.449,414.155,755.23,416.484,745.647Z",
    transform: "translate(-403.625 -720.78)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61806",
    "data-name": "Path 61806",
    d: "M473.956,745.479c-.677-.508-1.591-1.292-2.593-2.194-5.913,10.228-20.88,15.27-22.169,15.689.978,2.236,1.736,3.685,1.736,3.685S468.473,757.175,473.956,745.479Z",
    transform: "translate(-438.069 -737.791)",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183022",
    "data-name": "Group 183022",
    transform: "translate(136.334 2.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61807",
    "data-name": "Path 61807",
    d: "M926.426,815.854a1.462,1.462,0,0,1-.4-2.87c.594-.167,14.788-4.07,35.327-1.137a1.462,1.462,0,0,1-.414,2.895c-19.931-2.848-33.98,1.017-34.119,1.056A1.467,1.467,0,0,1,926.426,815.854Z",
    transform: "translate(-924.965 -791.721)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61808",
    "data-name": "Path 61808",
    d: "M975.472,754.739a1.462,1.462,0,0,1-1.46-1.406c0-.028-.108-2.83-.108-5.387,0-1.434,1.167-2.722,2.644-4.351,3.02-3.332,4-4.99,2.212-6.636a3.809,3.809,0,0,0-3.009-1.249c-1.949.215-3.428,2.321-3.443,2.342a1.462,1.462,0,0,1-2.414-1.65c.089-.131,2.226-3.22,5.513-3.6a6.623,6.623,0,0,1,5.336,2c4.2,3.877.3,8.178-2.029,10.748a11.277,11.277,0,0,0-1.887,2.416c0,2.494.1,5.219.105,5.246a1.462,1.462,0,0,1-1.4,1.517Z",
    transform: "translate(-958.736 -732.768)",
    fill: "url(#linear-gradient-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183023",
    "data-name": "Group 183023",
    transform: "translate(131.941 21.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61809",
    "data-name": "Path 61809",
    d: "M943.793,810.393c5.306-.634,16.7-1.707,25-.436a1.93,1.93,0,0,1,1.528,2.567,16.87,16.87,0,0,0,.455,11.982,3.094,3.094,0,0,1,.166,1.927l-3.409,14.318-20.468,1.1-4.142-15.187a3.068,3.068,0,0,1,.016-1.684c.57-1.923,1.7-7.049-.633-11.858A1.9,1.9,0,0,1,943.793,810.393Z",
    transform: "translate(-933.535 -809.364)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61810",
    "data-name": "Path 61810",
    d: "M966.919,1006.4s-7.676-40.206-25.22-63.964l-21.565.731s-13.524,35.82-13.158,65.426c0,0,6.214,4.752,18.275,1.462s12.793-.365,20.468,1.462S966.919,1006.4,966.919,1006.4Z",
    transform: "translate(-906.968 -909.95)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61811",
    "data-name": "Path 61811",
    d: "M959.116,928.871l.436,3.67s14.986,2.193,21.565-.731l-.352-3.431S966.131,930.348,959.116,928.871Z",
    transform: "translate(-946.386 -899.327)",
    fill: "url(#linear-gradient-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183026",
    "data-name": "Group 183026",
    transform: "translate(102.433 2.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61812",
    "data-name": "Path 61812",
    d: "M820.154,794.755s.365-4.752,6.214-3.655,13.158,1.828,15.717,0,9.151-1.253,7.676,2.558C845.374,804.989,820.154,794.755,820.154,794.755Z",
    transform: "translate(-811.838 -776.104)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183024",
    "data-name": "Group 183024",
    transform: "translate(16.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61813",
    "data-name": "Path 61813",
    d: "M858.682,754.739a1.462,1.462,0,0,1-1.46-1.406c0-.028-.108-2.83-.108-5.387,0-1.434,1.167-2.722,2.644-4.351,3.02-3.332,4-4.99,2.212-6.636a3.809,3.809,0,0,0-3.009-1.249c-1.949.215-3.428,2.321-3.443,2.342a1.462,1.462,0,0,1-2.414-1.65c.089-.131,2.226-3.22,5.513-3.6a6.623,6.623,0,0,1,5.336,2c4.2,3.877.3,8.178-2.029,10.748a11.279,11.279,0,0,0-1.887,2.416c0,2.494.1,5.219.105,5.246a1.462,1.462,0,0,1-1.4,1.517Z",
    transform: "translate(-852.853 -732.768)",
    fill: "url(#linear-gradient-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183025",
    "data-name": "Group 183025",
    transform: "translate(0 14.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61814",
    "data-name": "Path 61814",
    d: "M839.619,1139.717c.731-.365,25.22-.365,25.22-.365l-3.655-45.689-15.717.365Z",
    transform: "translate(-826.551 -1020.235)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61815",
    "data-name": "Path 61815",
    d: "M823.337,899.026h19.738l.731-61.406-28.144.366Z",
    transform: "translate(-808.442 -826.695)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61816",
    "data-name": "Path 61816",
    d: "M790.565,836.246c-2.527,7.654-6.94,30.56-2.742,60.847,0,0,2.193,1.828,5.483,0l1.462-63.964-.46.057A4.527,4.527,0,0,0,790.565,836.246Z",
    transform: "translate(-786.086 -823.3)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61817",
    "data-name": "Path 61817",
    d: "M930.159,828.76c-.3.159,11.057,22.938,12.45,61.9a2.7,2.7,0,0,1-2.66,2.719,6.482,6.482,0,0,1-2.484-.319c-1.828-.731-9.5-59.212-9.5-59.212Z",
    transform: "translate(-893.328 -819.997)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61818",
    "data-name": "Path 61818",
    d: "M807.348,832.1l5.259-.465s14.986,54.1,16.082,63.964c.9,8.056-7.708,34.864-10.9,44.442a6.107,6.107,0,0,1-6.593,4.169,6.468,6.468,0,0,1-2.245-.73S800.911,860.507,807.348,832.1Z",
    transform: "translate(-800.27 -822.168)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61819",
    "data-name": "Path 61819",
    d: "M899.469,831.631l-6.7,62.805a14.036,14.036,0,0,0,.242,4.478c1.972,9.052,9.364,42.713,10.482,43.831.981.981,2.694,1.011,4.287.745a4.481,4.481,0,0,0,3.746-4.436c-.041-10.819-.291-45.284-1.82-62.1-1.828-20.1-7.676-45.323-7.676-45.323h-2.558Z",
    transform: "translate(-866.664 -822.167)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61820",
    "data-name": "Path 61820",
    d: "M906.562,1088.953a1.279,1.279,0,1,1-1.279-1.279A1.279,1.279,0,0,1,906.562,1088.953Z",
    transform: "translate(-875.219 -1015.708)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61821",
    "data-name": "Path 61821",
    d: "M810.573,805.086s-3.041-1.664-1.214-7.877,7.31-1.462,12.062.365,13.524-2.558,16.082-4.02,6.579-1.462,6.579,8.772S820.925,819.908,810.573,805.086Z",
    transform: "translate(-803.237 -792.862)",
    fill: "url(#linear-gradient-39)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183028",
    "data-name": "Group 183028",
    transform: "translate(367.625 203.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61822",
    "data-name": "Path 61822",
    d: "M1636.171,1063.181a1.179,1.179,0,0,0,1.179-1.179V921.032a1.179,1.179,0,0,0-2.359,0V1062A1.179,1.179,0,0,0,1636.171,1063.181Z",
    transform: "translate(-1632.678 -919.005)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61823",
    "data-name": "Path 61823",
    d: "M1767.1,1063.181a1.179,1.179,0,0,0,1.179-1.179V921.032a1.179,1.179,0,0,0-2.359,0V1062A1.179,1.179,0,0,0,1767.1,1063.181Z",
    transform: "translate(-1731.645 -919.005)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61824",
    "data-name": "Path 61824",
    d: "M1902.015,1064.074a1.18,1.18,0,0,0,1.085-1.641l-60.31-141.864a1.179,1.179,0,0,0-2.171.923l60.31,141.864A1.18,1.18,0,0,0,1902.015,1064.074Z",
    transform: "translate(-1788.039 -919.004)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61825",
    "data-name": "Path 61825",
    d: "M1749.407,1064.074a1.18,1.18,0,0,0,1.085-1.641l-60.31-141.864a1.179,1.179,0,0,0-2.171.923l60.31,141.864A1.18,1.18,0,0,0,1749.407,1064.074Z",
    transform: "translate(-1672.684 -919.004)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61826",
    "data-name": "Path 61826",
    d: "M1626.2,919.7h57.2a.686.686,0,0,0,.686-.686v-1.952a.686.686,0,0,0-.686-.686h-57.2a.686.686,0,0,0-.686.686v1.952A.686.686,0,0,0,1626.2,919.7Z",
    transform: "translate(-1625.513 -916.38)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61827",
    "data-name": "Path 61827",
    d: "M1726.423,1011.074h37.363a1.179,1.179,0,0,0,0-2.359h-37.363a1.179,1.179,0,1,0,0,2.359Z",
    transform: "translate(-1700.899 -986.175)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149845",
    "data-name": "Rectangle 149845",
    width: 37.363,
    height: 2.359,
    transform: "translate(36.989 49.37)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149846",
    "data-name": "Rectangle 149846",
    width: 37.363,
    height: 2.359,
    transform: "translate(48.087 76.2)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61828",
    "data-name": "Path 61828",
    d: "M1866.531,1340.805h37.363a1.179,1.179,0,0,0,0-2.359h-37.363a1.179,1.179,0,1,0,0,2.359Z",
    transform: "translate(-1806.805 -1235.417)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61829",
    "data-name": "Path 61829",
    d: "M1912.628,1450.719h37.363a1.179,1.179,0,0,0,0-2.359h-37.363a1.179,1.179,0,1,0,0,2.359Z",
    transform: "translate(-1841.65 -1318.5)",
    fill: "#7d97f4"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183031",
    "data-name": "Group 183031",
    transform: "translate(296.888 227.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61830",
    "data-name": "Path 61830",
    d: "M1579.052,1216.755a18.463,18.463,0,0,0,4.292,3.138,35.657,35.657,0,0,1-7.846,6.977l-.971,2.178-3.11-3.727S1577,1222.544,1579.052,1216.755Z",
    transform: "translate(-1513.885 -1167.556)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61831",
    "data-name": "Path 61831",
    d: "M1534.519,1485.63a.765.765,0,0,1,.021-.2c1.007-3.993,6.006-6.48,6.006-6.48l1.981.155a13.738,13.738,0,0,1,.81,6.639c-.005.027-.013.052-.02.079A47,47,0,0,1,1534.519,1485.63Z",
    transform: "translate(-1485.993 -1365.746)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61832",
    "data-name": "Path 61832",
    d: "M1543.316,1506.513a.859.859,0,0,1-.629.635,27.168,27.168,0,0,1-7.57-.107.721.721,0,0,1-.6-.718A47.014,47.014,0,0,0,1543.316,1506.513Z",
    transform: "translate(-1485.994 -1386.437)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61833",
    "data-name": "Path 61833",
    d: "M1560.142,1467.5l-.839,4.039a.66.66,0,0,1-.564.543,5.584,5.584,0,0,1-1.3-.021.83.83,0,0,1-.657-.975l.583-3.586h2.777Z",
    transform: "translate(-1502.813 -1357.09)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61834",
    "data-name": "Path 61834",
    d: "M1471.433,1505.211a11.834,11.834,0,0,0,3.9-.558c0,.217,0,.439-.007.668a.432.432,0,0,1-.412.439l-12.012-.078a.549.549,0,0,1-.441-.8C1464.039,1505.015,1468.051,1505.306,1471.433,1505.211Z",
    transform: "translate(-1431.486 -1385.176)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61835",
    "data-name": "Path 61835",
    d: "M1462.636,1487.375a.545.545,0,0,1,.048-.091,15.307,15.307,0,0,1,9.1-5.714l2.561-.081a12.289,12.289,0,0,1,1.162,5.654,11.834,11.834,0,0,1-3.9.558C1468.222,1487.8,1464.211,1487.506,1462.636,1487.375Z",
    transform: "translate(-1431.658 -1367.667)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61836",
    "data-name": "Path 61836",
    d: "M1502.277,1463.664c-.028.191-.38,3.093-.515,4.217a.557.557,0,0,1-.47.5,5.864,5.864,0,0,1-1.759-.027.758.758,0,0,1-.574-.76v-4.555Z",
    transform: "translate(-1459.114 -1353.723)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61837",
    "data-name": "Path 61837",
    d: "M1502.184,1248.664a228.038,228.038,0,0,0-6.066,53.02,1.144,1.144,0,0,0,.907,1.115,13.32,13.32,0,0,0,2.864.331,1.061,1.061,0,0,0,1.011-.886c.866-5.08,5.837-33.7,8.669-38.341,0,0,1.863,25.487,1.268,38.709a.627.627,0,0,0,.553.652,10.544,10.544,0,0,0,2.3-.006.839.839,0,0,0,.747-.712c.617-4.3,4.168-29.888,4.017-48.322-.009-1.039-2.749-5.559-2.749-5.559h-13.521Z",
    transform: "translate(-1456.966 -1191.676)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61838",
    "data-name": "Path 61838",
    d: "M1485.777,1106.537a25.7,25.7,0,0,0,2.616-3.992c1.026-1.939.083,1.255.363-.934,7.684-5.545,19.255-2.738,23.731-2.174a5.977,5.977,0,0,1,3.777,2.028c3.835,4.438,12.251,16.59,2.345,28.834a18.461,18.461,0,0,1-4.292-3.138c1.1-3.089,1.186-7.037-1.111-11.879a11.367,11.367,0,0,1-.293,1.138,70.451,70.451,0,0,0-3.327,20.3.635.635,0,0,1-.4.593c-4.166,1.669-12.186.676-14.878.275a.905.905,0,0,1-.758-1.027c1.321-9.573-5.46-25.319-7.251-29.264A2.628,2.628,0,0,0,1485.777,1106.537Z",
    transform: "translate(-1449.15 -1077.961)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61839",
    "data-name": "Path 61839",
    d: "M1543.5,1069.448l.8,8.2s-4.615,1.39-7.972-.978l2.359-7.456Z",
    transform: "translate(-1487.36 -1056.033)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183029",
    "data-name": "Group 183029",
    transform: "translate(44.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61840",
    "data-name": "Path 61840",
    d: "M1529.242,1030.789c-.111.1-4.688,9.092-4.688,9.092l5.187,2.5,5.6-7.874S1531.1,1029.039,1529.242,1030.789Z",
    transform: "translate(-1523.113 -1026.724)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61841",
    "data-name": "Path 61841",
    d: "M1528.587,1023.213a.829.829,0,0,1-.062.727l-2.587,4.313a.807.807,0,0,1-.142.176,1.358,1.358,0,0,1-2.176-.015,7.3,7.3,0,0,0-2.044-2.21.827.827,0,0,0-1.116.367,30.922,30.922,0,0,0-1.771,4.2.823.823,0,0,0,.479,1.01,22.941,22.941,0,0,0,4.969,1.449.827.827,0,0,0,.782-.333c.793-1.086,3.026-4.12,3.789-4.879.708-.706,2.016-.44,2.6-.27a.833.833,0,0,0,.661-.087,1.823,1.823,0,0,0,.686-2.774.828.828,0,0,1,.256-1.125,1.831,1.831,0,0,0,.7-2.6,2.581,2.581,0,0,0-2.795-1.368.859.859,0,0,1-.9-.5.547.547,0,0,0-.427-.336.8.8,0,0,1-.65-.943,2.119,2.119,0,0,0-1.183-2.428c-2.238-1.231-4.2.775-4.7,2.467s2,2.889,3.578,3.088C1527.7,1021.291,1528.332,1022.553,1528.587,1023.213Z",
    transform: "translate(-1518.651 -1015.208)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61842",
    "data-name": "Path 61842",
    d: "M1555.869,1065.482s1-2.912,2.269-2.8,2.277,1.376.7,2.8C1556.872,1067.254,1555.869,1065.482,1555.869,1065.482Z",
    transform: "translate(-1546.784 -1051.087)",
    fill: "url(#linear-gradient-52)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61843",
    "data-name": "Path 61843",
    d: "M1598.5,1133.437a25.938,25.938,0,0,0,1.064-10.2l-.463.053a25.432,25.432,0,0,1-1.039,9.987Z",
    transform: "translate(-1534.028 -1096.866)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61844",
    "data-name": "Path 61844",
    d: "M1551.436,1293.839a.233.233,0,0,0,.225-.175c.512-1.976,4.348-4.147,4.387-4.169a.233.233,0,0,0-.228-.406c-.165.093-4.048,2.291-4.61,4.458a.233.233,0,0,0,.226.292Z",
    transform: "translate(-1498.605 -1222.21)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183030",
    "data-name": "Group 183030",
    transform: "translate(8.683 20.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61845",
    "data-name": "Path 61845",
    d: "M1418.232,1111c8.691,1.3,14.355-4.18,18.576-7.506,5.573-4.392,9.91-2.255,9.91-2.255l-5.943,11.342c-8.875,8.368-17.975,6.51-23.712,3.8A11.063,11.063,0,0,1,1418.232,1111Z",
    transform: "translate(-1405.885 -1100.724)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61846",
    "data-name": "Path 61846",
    d: "M1371.433,1121.6l2.882,1.551a25.22,25.22,0,0,0,9.333,3.634,11.061,11.061,0,0,0-1.169,5.379,26.6,26.6,0,0,1-5.941-3.8C1370.008,1124.472,1371.433,1121.6,1371.433,1121.6Z",
    transform: "translate(-1371.301 -1116.503)",
    fill: "url(#linear-gradient-56)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61847",
    "data-name": "Path 61847",
    d: "M1336.056,1116.67a2.125,2.125,0,0,1,1.243-1.36l5.849-2.352s.088-.75-1.236-1.26a1.76,1.76,0,0,1-1.015-1.993s1.809.825,4.457,2.134a6.2,6.2,0,0,1,2.815,3.065l-1.506,1.98a26.762,26.762,0,0,1-10.932.86Z",
    transform: "translate(-1335.733 -1086.638)",
    fill: "url(#linear-gradient-57)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183036",
    "data-name": "Group 183036",
    transform: "translate(35.141 216.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61848",
    "data-name": "Path 61848",
    d: "M376.395,1479.265s-.457,2.589-.682,5.152a1.766,1.766,0,0,0,1.689,1.913c3.413.142,10.714.419,13.334.3a.574.574,0,0,0,.506-.787h0a1.285,1.285,0,0,0-.658-.693l-12.06-5.543Z",
    transform: "translate(-348.309 -1355.176)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61849",
    "data-name": "Path 61849",
    d: "M376.991,1471.552l.367,3.1s2.113.983,3.555-.124l-.875-3.451Z",
    transform: "translate(-349.28 -1348.984)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61850",
    "data-name": "Path 61850",
    d: "M348.464,1234.507c-.159.809-.852,40.359,3.376,58.083a.6.6,0,0,1-.353.7,10.478,10.478,0,0,1-3.443.7,1.036,1.036,0,0,1-1.028-.744c-1.209-4.112-7-24.716-7.755-44.4-.844-21.993,0-.749,0-.749l.5-13.594Z",
    transform: "translate(-320.477 -1170.164)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61851",
    "data-name": "Path 61851",
    d: "M317.191,1484.8a18.639,18.639,0,0,0-1.433,4.78,1.077,1.077,0,0,0,.948,1.29c1.127.111,2.862.253,4.252.244a1.074,1.074,0,0,0,1.064-1.2,9.06,9.06,0,0,0-2.115-4.969Z",
    transform: "translate(-302.978 -1359.359)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61852",
    "data-name": "Path 61852",
    d: "M319.076,1467.917l.859,4.683a3.028,3.028,0,0,0,2.528.174l-.41-5.039Z",
    transform: "translate(-305.503 -1346.46)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61853",
    "data-name": "Path 61853",
    d: "M305.453,1232.707c-3.458,20.867.75,51.575,2.169,57.585a.938.938,0,0,0,.757.712,6.3,6.3,0,0,0,2.7-.108.859.859,0,0,0,.618-.791c.19-4.859-.152-34.689,3.069-46.478a2.679,2.679,0,0,1,1.033-1.477l6.253-4.445.479-7.186Z",
    transform: "translate(-294.199 -1167.149)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183032",
    "data-name": "Group 183032",
    transform: "translate(9.963 9.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61854",
    "data-name": "Path 61854",
    d: "M327.609,1072.265c-10.362-.171-21.8,2.721-21.8,2.721-3.089,18.022-.54,38.81-.54,38.81,8.022,2.1,17.071-1.286,17.071-1.286,1.333-7.533,7.554-28.733,7.554-28.733a34.132,34.132,0,0,0,12.668-4.02,22.217,22.217,0,0,1-4.391-9.185A34.782,34.782,0,0,1,327.609,1072.265Z",
    transform: "translate(-304.286 -1056.217)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61855",
    "data-name": "Path 61855",
    d: "M463.159,1012.553a1.983,1.983,0,0,0-2.306-.648c-1.525,6.441-9.52,11.664-17.734,14.217a22.22,22.22,0,0,0,4.391,9.185C461.142,1027.642,463.159,1012.553,463.159,1012.553Z",
    transform: "translate(-409.229 -1011.768)",
    fill: "url(#linear-gradient-59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183033",
    "data-name": "Group 183033",
    transform: "translate(61.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61856",
    "data-name": "Path 61856",
    d: "M517.827,981.993c.106.339-1.127.854-1.853-.531-.025-.664-.429-3.507-.032-4.048a52.959,52.959,0,0,1,6.207-6.49.974.974,0,0,1,.122,1.354l-1.987,2.07a9.605,9.605,0,0,1,1.16,2.293,2.784,2.784,0,0,1-.278,2.049c-.349.628-.825,1.445-1.274,2.084A2.748,2.748,0,0,1,517.827,981.993Z",
    transform: "translate(-515.768 -970.925)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61857",
    "data-name": "Path 61857",
    d: "M523.345,990.45l-1.81,1.535-.568,1.528,1.614,1.791a20.81,20.81,0,0,1,.946-3.688C523.929,990.959,523.72,990.642,523.345,990.45Z",
    transform: "translate(-519.697 -985.684)",
    fill: "url(#linear-gradient-67)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61858",
    "data-name": "Path 61858",
    d: "M279.622,1098.688l-3.974-10.033s-9.679,6.576-11.27,14.914a22.9,22.9,0,0,1,8.414,2.255C273.506,1101.887,279.622,1098.688,279.622,1098.688Z",
    transform: "translate(-264.156 -1059.916)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61859",
    "data-name": "Path 61859",
    d: "M287.4,1154.311s-10.867,6.141-14.533.9a4.122,4.122,0,0,1-.756-3.2,22.9,22.9,0,0,0-8.414-2.255,11.507,11.507,0,0,0,1.251,7.889c6.423,11.749,23.89-.649,23.89-.649Z",
    transform: "translate(-263.472 -1106.098)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183034",
    "data-name": "Group 183034",
    transform: "translate(22.594 31.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61860",
    "data-name": "Path 61860",
    d: "M356.054,1130.8l5.931-20.711a.6.6,0,0,1,.511-.435c1.075-.125,4.188-.477,7.783-.781a88.336,88.336,0,0,1,12.364-.411.606.606,0,0,1,.5.872c-1.709,3.457-8.738,17.52-12.258,22.127a.608.608,0,0,1-.489.24l-13.76-.128A.606.606,0,0,1,356.054,1130.8Z",
    transform: "translate(-356.03 -1106.355)",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61861",
    "data-name": "Path 61861",
    d: "M415.3,1100.847l4.3-.716a.309.309,0,0,1,.344.4l-.426,1.29a.309.309,0,0,1-.252.209l-4.138.553a.309.309,0,0,1-.341-.376l.263-1.126A.308.308,0,0,1,415.3,1100.847Z",
    transform: "translate(-400.441 -1100.126)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61862",
    "data-name": "Path 61862",
    d: "M403.7,1108.477l.354-1.845a.427.427,0,0,1,.376-.344l8.685-.881a.426.426,0,0,1,.458.524l-.552,2.3a.427.427,0,0,1-.393.326l-8.487.427A.427.427,0,0,1,403.7,1108.477Z",
    transform: "translate(-392.061 -1104.116)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61863",
    "data-name": "Path 61863",
    d: "M360.226,1157.9s-.826-3.4-.493-4.6.979-2.755,3.131-2.411a31.486,31.486,0,0,1,4.691,1.251,1.232,1.232,0,0,1-1.764,1.063l1.014.785s-.145,1.257-1.527.585l.943,1.041a1.1,1.1,0,0,1-1.61.37C363.6,1155.317,363.108,1158.3,360.226,1157.9Z",
    transform: "translate(-358.769 -1138.456)",
    fill: "url(#linear-gradient-59)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61864",
    "data-name": "Path 61864",
    d: "M346.565,1043.048l-3.3,9.535a.343.343,0,0,0,.157.414,7.75,7.75,0,0,0,8.039-.541,1.618,1.618,0,0,0,.745-1.155l1.068-8.252Z",
    transform: "translate(-323.775 -1025.442)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183035",
    "data-name": "Group 183035",
    transform: "translate(16.533 3.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61865",
    "data-name": "Path 61865",
    d: "M360.054,1006.877s3.621,6.815,3.156,9.568-4.951,2.555-8.869.32l-2.738-7.359Z",
    transform: "translate(-346.623 -1001.922)",
    fill: "url(#linear-gradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61866",
    "data-name": "Path 61866",
    d: "M339.092,997.807a.281.281,0,0,0,.123-.411,7.331,7.331,0,0,1-1.007-2.139s-.651-.417,1.657-.969,5.748-1.409,6.472-3.374c.705-1.915-1.148-6.731-4.1-2.893a.281.281,0,0,1-.445,0,2.9,2.9,0,0,0-3.527-1.146,2.656,2.656,0,0,0-1.819,2.567.279.279,0,0,1-.331.286,3.24,3.24,0,0,0-3.782,1.763c-.772,1.7-.27,2.657.187,3.127a.28.28,0,0,1-.12.465,1.685,1.685,0,0,0-1.189,1.923c.1,1.781,2.09,1.624,2.657,1.543a.282.282,0,0,1,.249.088c.486.538,2.677,2.823,5.048,3.1a.283.283,0,0,0,.3-.374l-1.026-2.982a.282.282,0,0,1,.153-.35Z",
    transform: "translate(-331.201 -986.578)",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61867",
    "data-name": "Path 61867",
    d: "M356.621,1031.6s-2.578-1.769-2.766-.279,2.321,2.157,3.564,1.6Z",
    transform: "translate(-348.317 -1019.948)",
    fill: "url(#linear-gradient-75)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183039",
    "data-name": "Group 183039",
    transform: "translate(458.132 252.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183037",
    "data-name": "Group 183037",
    transform: "translate(24.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61868",
    "data-name": "Path 61868",
    d: "M2127.153,1143.392H2097.1v-.732c0-7.891,1.521-14.718,4.4-19.742,2.649-4.626,6.356-7.356,10.17-7.49,3.743-.131,7.285,2.189,9.975,6.536,2.956,4.777,4.843,11.916,5.458,20.644Zm-28.585-1.465h27.01c-.652-8.134-2.439-14.758-5.183-19.193-2.4-3.88-5.487-5.957-8.677-5.843C2105.436,1117.112,2098.765,1125.953,2098.567,1141.927Z",
    transform: "translate(-2097.098 -1115.422)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61869",
    "data-name": "Path 61869",
    d: "M1996.315,1273.757l10.423-70.665,39.157-.647,12.621,75.24h-58.811A3.427,3.427,0,0,1,1996.315,1273.757Z",
    transform: "translate(-1996.278 -1181.202)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61870",
    "data-name": "Path 61870",
    d: "M2207.145,1203.092l-7.6-.647,12.621,75.24h7.55a2.413,2.413,0,0,0,2.362-2.905Z",
    transform: "translate(-2149.922 -1181.202)",
    fill: "url(#linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183038",
    "data-name": "Group 183038",
    transform: "translate(16.067 0.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61871",
    "data-name": "Path 61871",
    d: "M2092.152,1145.391H2062.1v-.732c0-7.891,1.521-14.718,4.4-19.742,2.649-4.626,6.356-7.356,10.17-7.49,3.746-.132,7.285,2.189,9.975,6.536,2.956,4.777,4.843,11.916,5.457,20.645Zm-28.585-1.465h27.01c-.652-8.134-2.439-14.758-5.183-19.193-2.4-3.88-5.487-5.955-8.677-5.843C2070.435,1119.112,2063.765,1127.952,2063.567,1143.927Z",
    transform: "translate(-2062.098 -1117.422)",
    fill: "url(#linear-gradient-2)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183042",
    "data-name": "Group 183042",
    transform: "translate(424.152 279.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183040",
    "data-name": "Group 183040",
    transform: "translate(23.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61872",
    "data-name": "Path 61872",
    d: "M1984.153,1254.392H1954.1v-.732c0-7.891,1.521-14.718,4.4-19.742,2.649-4.626,6.356-7.356,10.17-7.49,3.746-.131,7.285,2.189,9.974,6.536,2.956,4.777,4.843,11.916,5.458,20.645Zm-28.585-1.465h27.01c-.652-8.134-2.439-14.758-5.183-19.193-2.4-3.88-5.484-5.956-8.678-5.843C1962.436,1228.112,1955.765,1236.953,1955.567,1252.927Z",
    transform: "translate(-1954.098 -1226.422)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_61873",
    "data-name": "Path 61873",
    d: "M1857.117,1358.433l10.423-43.32,39.157-.647,12.621,47.895h-58.811A3.428,3.428,0,0,1,1857.117,1358.433Z",
    transform: "translate(-1857.08 -1292.974)",
    fill: "url(#linear-gradient-80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61874",
    "data-name": "Path 61874",
    d: "M2067.947,1315.113l-7.6-.647,12.621,47.895h7.55a2.413,2.413,0,0,0,2.363-2.905Z",
    transform: "translate(-2010.724 -1292.974)",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183041",
    "data-name": "Group 183041",
    transform: "translate(15.627 1.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61875",
    "data-name": "Path 61875",
    d: "M1951.153,1259.392H1921.1v-.732c0-7.891,1.521-14.718,4.4-19.742,2.649-4.626,6.356-7.356,10.17-7.49,3.744-.131,7.285,2.189,9.974,6.536,2.956,4.777,4.843,11.916,5.458,20.644Zm-28.585-1.465h27.01c-.652-8.134-2.439-14.758-5.183-19.193-2.4-3.88-5.486-5.955-8.678-5.843C1929.436,1233.112,1922.765,1241.953,1922.567,1257.927Z",
    transform: "translate(-1921.098 -1231.422)",
    fill: "url(#linear-gradient-2)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183043",
    "data-name": "Group 183043",
    transform: "translate(98.08 117.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61876",
    "data-name": "Path 61876",
    d: "M1658.341,563.273l-.476,1.408a.5.5,0,0,1-.955-.323l0-.006.493-1.4a.5.5,0,0,1,.936.323Z",
    transform: "translate(-1379.681 -562.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61877",
    "data-name": "Path 61877",
    d: "M1651.633,582.364l-.48,1.406a.533.533,0,1,1-1.009-.345l0-.006.5-1.4a.524.524,0,0,1,.99.345Z",
    transform: "translate(-1374.564 -577.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61878",
    "data-name": "Path 61878",
    d: "M1644.845,601.429l-.487,1.4a.562.562,0,0,1-1.062-.369l0-.006.5-1.4a.553.553,0,0,1,1.043.369Z",
    transform: "translate(-1369.386 -591.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61879",
    "data-name": "Path 61879",
    d: "M1637.943,620.459l-.5,1.4a.591.591,0,0,1-1.115-.4l0-.007.513-1.394a.583.583,0,0,1,1.1.4Z",
    transform: "translate(-1364.12 -605.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61880",
    "data-name": "Path 61880",
    d: "M1630.891,639.441l-.509,1.4a.62.62,0,0,1-1.166-.425l0-.007.525-1.389a.612.612,0,0,1,1.147.425Z",
    transform: "translate(-1358.739 -620.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61881",
    "data-name": "Path 61881",
    d: "M1623.656,658.356l-.523,1.39a.65.65,0,0,1-1.216-.458l0-.007.539-1.384a.641.641,0,0,1,1.2.458Z",
    transform: "translate(-1353.218 -634.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61882",
    "data-name": "Path 61882",
    d: "M1616.2,677.2l-.54,1.384a.679.679,0,1,1-1.265-.494l0-.007.557-1.377a.67.67,0,0,1,1.245.495Z",
    transform: "translate(-1347.531 -648.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61883",
    "data-name": "Path 61883",
    d: "M1608.5,695.938l-.56,1.376a.708.708,0,1,1-1.311-.534l0-.008.576-1.369a.7.7,0,0,1,1.292.535Z",
    transform: "translate(-1341.651 -662.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61884",
    "data-name": "Path 61884",
    d: "M1600.5,714.569l-.582,1.367a.737.737,0,1,1-1.356-.578l0-.008.6-1.36a.728.728,0,0,1,1.337.579Z",
    transform: "translate(-1335.552 -676.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61885",
    "data-name": "Path 61885",
    d: "M1592.187,733.069l-.606,1.356a.766.766,0,0,1-1.4-.626l0-.008.622-1.349a.758.758,0,0,1,1.379.627Z",
    transform: "translate(-1329.21 -690.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61886",
    "data-name": "Path 61886",
    d: "M1583.546,751.427l-.638,1.343a.784.784,0,0,1-1.417-.673l0,0,.646-1.339a.779.779,0,0,1,1.406.673Z",
    transform: "translate(-1322.635 -704.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61887",
    "data-name": "Path 61887",
    d: "M1574.513,769.64l-.666,1.328a.8.8,0,0,1-1.432-.718l0,0,.675-1.323a.8.8,0,0,1,1.42.718Z",
    transform: "translate(-1315.767 -718.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61888",
    "data-name": "Path 61888",
    d: "M1565.068,787.635l-.7,1.311a.817.817,0,0,1-1.443-.767l0,0,.706-1.306a.812.812,0,0,1,1.432.768Z",
    transform: "translate(-1308.588 -731.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61889",
    "data-name": "Path 61889",
    d: "M1555.175,805.4l-.731,1.292a.833.833,0,0,1-1.451-.821l0,0,.739-1.287a.829.829,0,0,1,1.44.821Z",
    transform: "translate(-1301.069 -745.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61890",
    "data-name": "Path 61890",
    d: "M1544.8,822.893l-.766,1.271a.85.85,0,1,1-1.455-.878l0,0,.775-1.265a.845.845,0,0,1,1.444.877Z",
    transform: "translate(-1293.19 -758.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61891",
    "data-name": "Path 61891",
    d: "M1533.933,840.09l-.8,1.248a.866.866,0,0,1-1.456-.938l0,0,.812-1.242a.861.861,0,0,1,1.445.938Z",
    transform: "translate(-1284.93 -771.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61892",
    "data-name": "Path 61892",
    d: "M1522.539,856.956l-.843,1.223a.883.883,0,1,1-1.453-1l0,0,.851-1.217a.878.878,0,0,1,1.442,1Z",
    transform: "translate(-1276.276 -784.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61893",
    "data-name": "Path 61893",
    d: "M1510.575,873.455l-.887,1.192a.9.9,0,0,1-1.442-1.073l0,0,.894-1.186a.894.894,0,0,1,1.431,1.072Z",
    transform: "translate(-1267.192 -796.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61894",
    "data-name": "Path 61894",
    d: "M1498.011,889.515l-.93,1.158a.915.915,0,1,1-1.427-1.147l0,0,.938-1.152a.91.91,0,0,1,1.416,1.145Z",
    transform: "translate(-1257.655 -808.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61895",
    "data-name": "Path 61895",
    d: "M1484.854,905.1l-.974,1.122a.932.932,0,0,1-1.408-1.221l0,0,.981-1.115a.927.927,0,0,1,1.4,1.22Z",
    transform: "translate(-1247.672 -820.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61896",
    "data-name": "Path 61896",
    d: "M1471.109,920.179l-1.016,1.083a.948.948,0,0,1-1.383-1.3l0,0,1.024-1.077a.943.943,0,0,1,1.371,1.3Z",
    transform: "translate(-1237.247 -831.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61897",
    "data-name": "Path 61897",
    d: "M1456.795,934.711l-1.061,1.039a.961.961,0,0,1-1.344-1.373h0l1.064-1.037a.959.959,0,0,1,1.341,1.372Z",
    transform: "translate(-1226.398 -842.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61898",
    "data-name": "Path 61898",
    d: "M1441.91,948.687l-1.1.994a.966.966,0,1,1-1.294-1.436h0l1.106-.992a.965.965,0,0,1,1.29,1.435Z",
    transform: "translate(-1215.13 -853.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61899",
    "data-name": "Path 61899",
    d: "M1426.447,962.031l-1.146.945a.972.972,0,1,1-1.237-1.5h0l1.148-.943a.97.97,0,0,1,1.233,1.5Z",
    transform: "translate(-1203.428 -863.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61900",
    "data-name": "Path 61900",
    d: "M1410.412,974.69l-1.187.893a.977.977,0,0,1-1.174-1.562h0l1.189-.89a.975.975,0,0,1,1.171,1.561Z",
    transform: "translate(-1191.294 -872.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61901",
    "data-name": "Path 61901",
    d: "M1393.814,986.607l-1.228.836a.983.983,0,1,1-1.105-1.625h0l1.23-.833a.981.981,0,0,1,1.1,1.623Z",
    transform: "translate(-1178.739 -881.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61902",
    "data-name": "Path 61902",
    d: "M1376.662,997.723l-1.268.774a.988.988,0,1,1-1.029-1.687h0l1.27-.771a.986.986,0,0,1,1.025,1.685Z",
    transform: "translate(-1165.769 -890.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61903",
    "data-name": "Path 61903",
    d: "M1358.971,1007.969l-1.307.708a.993.993,0,1,1-.946-1.747h0l1.309-.7a.992.992,0,0,1,.942,1.746Z",
    transform: "translate(-1152.394 -897.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61904",
    "data-name": "Path 61904",
    d: "M1340.778,1017.278l-1.341.634a1,1,0,0,1-.854-1.806h0l1.343-.631a1,1,0,0,1,.851,1.8Z",
    transform: "translate(-1138.647 -904.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61905",
    "data-name": "Path 61905",
    d: "M1322.1,1025.574l-1.376.558a1,1,0,1,1-.754-1.862h0l1.378-.555a1,1,0,0,1,.751,1.859Z",
    transform: "translate(-1124.535 -911.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61906",
    "data-name": "Path 61906",
    d: "M1302.978,1032.792l-1.407.475a1.01,1.01,0,1,1-.647-1.913h0l1.408-.473a1.008,1.008,0,0,1,.643,1.911Z",
    transform: "translate(-1110.094 -916.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61907",
    "data-name": "Path 61907",
    d: "M1283.467,1038.859l-1.434.388a1.015,1.015,0,0,1-.531-1.96h0l1.435-.385a1.013,1.013,0,0,1,.528,1.957Z",
    transform: "translate(-1095.366 -921.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61908",
    "data-name": "Path 61908",
    d: "M1263.634,1043.711l-1.454.3a1.02,1.02,0,1,1-.408-2h0l1.454-.294a1.019,1.019,0,0,1,.406,2Z",
    transform: "translate(-1080.401 -924.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61909",
    "data-name": "Path 61909",
    d: "M1243.553,1047.3l-1.471.2a1.026,1.026,0,0,1-.282-2.032h0l1.472-.2a1.024,1.024,0,0,1,.279,2.03Z",
    transform: "translate(-1065.253 -927.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61910",
    "data-name": "Path 61910",
    d: "M1223.3,1049.617l-1.481.114a1.031,1.031,0,1,1-.159-2.057h0l1.481-.111a1.03,1.03,0,0,1,.156,2.053Z",
    transform: "translate(-1049.977 -929.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61911",
    "data-name": "Path 61911",
    d: "M1202.962,1050.733l-1.485.029a1.037,1.037,0,0,1-.041-2.073h0l1.485-.026a1.035,1.035,0,0,1,.039,2.07Z",
    transform: "translate(-1034.643 -930.016)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61912",
    "data-name": "Path 61912",
    d: "M1182.612,1050.554l-1.484-.05a1.042,1.042,0,1,1,.069-2.083h0l1.484.053a1.041,1.041,0,0,1-.072,2.08Z",
    transform: "translate(-1019.299 -929.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61913",
    "data-name": "Path 61913",
    d: "M1162.328,1049.276l-1.48-.126a1.042,1.042,0,0,1,.174-2.077l1.48.122a1.044,1.044,0,1,1-.172,2.081Z",
    transform: "translate(-1004.009 -928.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61914",
    "data-name": "Path 61914",
    d: "M1142.142,1047.063l-1.473-.192a1.036,1.036,0,0,1,.265-2.056l1.473.188a1.038,1.038,0,0,1-.263,2.059Z",
    transform: "translate(-988.795 -927.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61915",
    "data-name": "Path 61915",
    d: "M1122.071,1044l-1.464-.252a1.03,1.03,0,0,1,.347-2.031l1.464.248a1.032,1.032,0,0,1-.345,2.036Z",
    transform: "translate(-973.666 -924.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61916",
    "data-name": "Path 61916",
    d: "M1102.143,1040.159l-1.452-.305a1.025,1.025,0,0,1,.419-2.006l1.453.3a1.026,1.026,0,0,1-.417,2.01Z",
    transform: "translate(-958.643 -921.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61917",
    "data-name": "Path 61917",
    d: "M1082.359,1035.632l-1.444-.354a1.019,1.019,0,0,1,.482-1.979l1.445.35a1.021,1.021,0,1,1-.481,1.984Z",
    transform: "translate(-943.723 -918.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61918",
    "data-name": "Path 61918",
    d: "M1062.728,1030.493l-1.432-.4a1.013,1.013,0,0,1,.538-1.953l1.433.393a1.015,1.015,0,1,1-.536,1.957Z",
    transform: "translate(-928.919 -914.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61919",
    "data-name": "Path 61919",
    d: "M1043.253,1024.815l-1.421-.433a1.007,1.007,0,0,1,.585-1.927l1.422.43a1.009,1.009,0,0,1-.584,1.931Z",
    transform: "translate(-914.229 -910.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61920",
    "data-name": "Path 61920",
    d: "M1023.918,1018.664l-1.413-.466a1,1,0,0,1,.626-1.9l1.414.463a1,1,0,1,1-.624,1.906Z",
    transform: "translate(-899.639 -905.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61921",
    "data-name": "Path 61921",
    d: "M1004.721,1012.106l-1.4-.495a1,1,0,0,1,.662-1.877l1.4.49h0a1,1,0,1,1-.658,1.882Z",
    transform: "translate(-885.152 -900.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61922",
    "data-name": "Path 61922",
    d: "M985.639,1005.219l-1.4-.515a.989.989,0,0,1,.683-1.857l1.4.511a.991.991,0,0,1-.682,1.862Z",
    transform: "translate(-870.748 -895.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61923",
    "data-name": "Path 61923",
    d: "M966.655,998.113l-1.388-.528a.983.983,0,0,1,.7-1.839l1.389.525a.985.985,0,0,1-.7,1.844Z",
    transform: "translate(-856.413 -889.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61924",
    "data-name": "Path 61924",
    d: "M947.731,990.861l-1.385-.536a.978.978,0,0,1,.7-1.824l1.386.533a.979.979,0,0,1-.7,1.828Z",
    transform: "translate(-842.118 -884.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61925",
    "data-name": "Path 61925",
    d: "M928.836,983.548l-1.384-.539a.972.972,0,0,1,.7-1.812l1.386.535a.974.974,0,0,1-.7,1.816Z",
    transform: "translate(-827.84 -878.969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61926",
    "data-name": "Path 61926",
    d: "M909.937,976.256l-1.386-.535a.966.966,0,0,1,.693-1.8l1.387.531a.968.968,0,0,1-.692,1.808Z",
    transform: "translate(-813.554 -873.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61927",
    "data-name": "Path 61927",
    d: "M891,969.07l-1.39-.524a.96.96,0,0,1,.676-1.8l1.391.521a.962.962,0,1,1-.675,1.8Z",
    transform: "translate(-799.237 -868.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61928",
    "data-name": "Path 61928",
    d: "M872.044,962.1l-1.394-.512a.944.944,0,0,1,.644-1.775l1.4.5a.95.95,0,0,1-.641,1.788Z",
    transform: "translate(-784.904 -862.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61929",
    "data-name": "Path 61929",
    d: "M852.986,955.389l-1.4-.49a.926.926,0,0,1,.6-1.752l1.408.48a.932.932,0,0,1-.6,1.764Z",
    transform: "translate(-770.489 -857.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61930",
    "data-name": "Path 61930",
    d: "M833.8,949.037l-1.413-.461a.909.909,0,0,1,.557-1.73l1.416.451a.914.914,0,0,1-.554,1.742Z",
    transform: "translate(-755.978 -853.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61931",
    "data-name": "Path 61931",
    d: "M814.5,943.135l-1.423-.425a.891.891,0,0,1,.5-1.709l1.426.415a.9.9,0,0,1-.5,1.721Z",
    transform: "translate(-741.37 -848.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61932",
    "data-name": "Path 61932",
    d: "M795.048,937.771l-1.434-.383a.873.873,0,0,1,.444-1.689l1.437.372a.879.879,0,0,1-.441,1.7Z",
    transform: "translate(-726.652 -844.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61933",
    "data-name": "Path 61933",
    d: "M775.432,933.03l-1.446-.334a.856.856,0,0,1,.38-1.668l1.449.324a.861.861,0,1,1-.376,1.68Z",
    transform: "translate(-711.804 -841.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61934",
    "data-name": "Path 61934",
    d: "M755.654,929.009l-1.459-.278a.838.838,0,0,1,.308-1.647l1.461.267a.843.843,0,0,1-.3,1.659Z",
    transform: "translate(-696.83 -838.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61935",
    "data-name": "Path 61935",
    d: "M735.72,925.868l-1.471-.209a.82.82,0,0,1,.225-1.625l1.472.2a.825.825,0,1,1-.221,1.636Z",
    transform: "translate(-681.736 -835.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61936",
    "data-name": "Path 61936",
    d: "M715.658,923.686l-1.479-.138a.8.8,0,0,1,.143-1.6l1.48.127a.808.808,0,0,1-.138,1.609Z",
    transform: "translate(-666.547 -834.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61937",
    "data-name": "Path 61937",
    d: "M695.51,922.5l-1.484-.062a.785.785,0,0,1,.061-1.568l1.484.052a.79.79,0,0,1-.055,1.579Z",
    transform: "translate(-651.295 -833.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61938",
    "data-name": "Path 61938",
    d: "M675.338,922.3l-1.485.014a.764.764,0,0,1-.023-1.528l1.485-.03a.772.772,0,0,1,.031,1.544Z",
    transform: "translate(-636.031 -833.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61939",
    "data-name": "Path 61939",
    d: "M655.222,923.061l-1.482.1a.733.733,0,0,1-.106-1.462l1.481-.117a.742.742,0,1,1,.117,1.48Z",
    transform: "translate(-620.821 -833.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61940",
    "data-name": "Path 61940",
    d: "M635.2,925.013l-1.473.188a.7.7,0,0,1-.187-1.39l1.471-.207a.711.711,0,1,1,.2,1.407Z",
    transform: "translate(-605.683 -835.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61941",
    "data-name": "Path 61941",
    d: "M615.35,928.23l-1.458.286a.67.67,0,0,1-.266-1.313l1.454-.3a.679.679,0,0,1,.278,1.329Z",
    transform: "translate(-590.688 -837.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61942",
    "data-name": "Path 61942",
    d: "M595.79,932.8l-1.433.389a.638.638,0,0,1-.342-1.23l1.429-.407a.648.648,0,0,1,.355,1.245Z",
    transform: "translate(-575.916 -841.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61943",
    "data-name": "Path 61943",
    d: "M576.646,938.81l-1.4.5a.607.607,0,0,1-.415-1.14l1.391-.516a.616.616,0,1,1,.429,1.155Z",
    transform: "translate(-561.468 -846.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61944",
    "data-name": "Path 61944",
    d: "M558.073,946.33l-1.353.613a.575.575,0,0,1-.481-1.044l1.345-.63a.584.584,0,0,1,.5,1.058Z",
    transform: "translate(-547.461 -851.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61945",
    "data-name": "Path 61945",
    d: "M540.237,955.424l-1.294.73a.543.543,0,0,1-.54-.943l1.284-.747a.553.553,0,0,1,.556.956Z",
    transform: "translate(-534.025 -858.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61946",
    "data-name": "Path 61946",
    d: "M523.33,966.111l-1.22.847a.512.512,0,0,1-.59-.837l1.209-.863a.521.521,0,1,1,.606.849Z",
    transform: "translate(-521.306 -866.898)",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_183044",
    "data-name": "Group 183044",
    transform: "translate(127.981 72.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61947",
    "data-name": "Path 61947",
    d: "M1591.111,627.084l-.707,1.308a.514.514,0,0,1-.905-.489l.006-.011.74-1.29a.5.5,0,0,1,.865.482Z",
    transform: "translate(-1358.6 -566.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61948",
    "data-name": "Path 61948",
    d: "M1580.444,644.454l-.786,1.26a.578.578,0,0,1-.981-.612l.008-.013.819-1.24a.559.559,0,0,1,.94.6Z",
    transform: "translate(-1350.4 -579.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61949",
    "data-name": "Path 61949",
    d: "M1568.769,661.163l-.865,1.207a.629.629,0,1,1-1.021-.733l.007-.01.888-1.19a.614.614,0,0,1,.992.725Z",
    transform: "translate(-1341.461 -591.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61950",
    "data-name": "Path 61950",
    d: "M1556.109,677.179l-.936,1.153a.676.676,0,0,1-1.05-.852l.008-.01.958-1.135a.662.662,0,0,1,1.019.844Z",
    transform: "translate(-1331.792 -603.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61951",
    "data-name": "Path 61951",
    d: "M1542.521,692.437l-1,1.1a.723.723,0,0,1-1.068-.976l.01-.01,1.023-1.077a.709.709,0,0,1,1.037.967Z",
    transform: "translate(-1321.428 -615.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61952",
    "data-name": "Path 61952",
    d: "M1528.061,706.9,1527,707.939a.771.771,0,0,1-1.076-1.1l.011-.01,1.084-1.016a.757.757,0,0,1,1.046,1.094Z",
    transform: "translate(-1310.412 -625.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61953",
    "data-name": "Path 61953",
    d: "M1512.818,720.531l-1.126.97a.81.81,0,0,1-1.058-1.228l.007-.006,1.137-.956a.8.8,0,0,1,1.039,1.221Z",
    transform: "translate(-1298.821 -636.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61954",
    "data-name": "Path 61954",
    d: "M1496.833,733.33l-1.18.9a.839.839,0,0,1-1.021-1.333l.008-.006,1.19-.89a.831.831,0,0,1,1,1.325Z",
    transform: "translate(-1286.689 -645.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61955",
    "data-name": "Path 61955",
    d: "M1480.156,745.214l-1.229.836a.868.868,0,1,1-.977-1.436l.009-.006,1.239-.821a.86.86,0,0,1,.958,1.427Z",
    transform: "translate(-1274.04 -654.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61956",
    "data-name": "Path 61956",
    d: "M1462.837,756.146l-1.275.765a.9.9,0,0,1-.923-1.539l.009-.005,1.284-.75a.889.889,0,0,1,.906,1.53Z",
    transform: "translate(-1260.912 -662.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61957",
    "data-name": "Path 61957",
    d: "M1444.921,766.1l-1.316.691a.927.927,0,1,1-.861-1.641l.01-.005,1.324-.675a.918.918,0,0,1,.844,1.63Z",
    transform: "translate(-1247.34 -670.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61958",
    "data-name": "Path 61958",
    d: "M1426.477,775.017l-1.353.614a.956.956,0,1,1-.79-1.74l.01,0,1.36-.6a.947.947,0,0,1,.772,1.729Z",
    transform: "translate(-1233.375 -677.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61959",
    "data-name": "Path 61959",
    d: "M1407.562,782.873l-1.386.534a.984.984,0,1,1-.708-1.837l.011,0,1.392-.518a.976.976,0,0,1,.692,1.825Z",
    transform: "translate(-1219.062 -682.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61960",
    "data-name": "Path 61960",
    d: "M1388.256,789.619l-1.416.447a1.009,1.009,0,0,1-.607-1.924h0l1.418-.44a1,1,0,0,1,.6,1.918Z",
    transform: "translate(-1204.465 -687.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61961",
    "data-name": "Path 61961",
    d: "M1368.629,795.261l-1.44.361a1.018,1.018,0,0,1-.495-1.975h0l1.442-.355a1.015,1.015,0,0,1,.489,1.971Z",
    transform: "translate(-1189.647 -692.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61962",
    "data-name": "Path 61962",
    d: "M1348.707,799.722l-1.46.272a1.028,1.028,0,1,1-.377-2.021h0l1.46-.267a1.025,1.025,0,0,1,.372,2.016Z",
    transform: "translate(-1174.61 -695.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    "data-name": "Path 61963",
    d: "M1328.556,802.958l-1.474.181a1.037,1.037,0,1,1-.253-2.059h0l1.475-.175a1.034,1.034,0,0,1,.248,2.054Z",
    transform: "translate(-1159.407 -697.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61964",
    "data-name": "Path 61964",
    d: "M1308.244,804.935l-1.483.089a1.047,1.047,0,0,1-.125-2.09h0l1.484-.083a1.044,1.044,0,0,1,.12,2.085Z",
    transform: "translate(-1144.088 -699.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M1287.879,805.622l-1.485,0a1.057,1.057,0,1,1,0-2.113h0l1.485.008a1.054,1.054,0,0,1-.008,2.108Z",
    transform: "translate(-1128.735 -699.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61966",
    "data-name": "Path 61966",
    d: "M1267.531,804.82l-1.482-.092a1.066,1.066,0,0,1,.132-2.128h0l1.481.1a1.063,1.063,0,0,1-.135,2.122Z",
    transform: "translate(-1113.397 -699.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61967",
    "data-name": "Path 61967",
    d: "M1247.266,802.81l-1.474-.179a1.076,1.076,0,1,1,.26-2.136h0l1.473.185a1.073,1.073,0,0,1-.263,2.129Z",
    transform: "translate(-1098.126 -697.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61968",
    "data-name": "Path 61968",
    d: "M1227.147,799.616l-1.461-.265a1.085,1.085,0,0,1,.387-2.136h0l1.46.27a1.083,1.083,0,0,1-.39,2.13Z",
    transform: "translate(-1082.968 -695.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61969",
    "data-name": "Path 61969",
    d: "M1207.238,795.266l-1.444-.349a1.095,1.095,0,1,1,.514-2.129h0l1.443.354a1.092,1.092,0,0,1-.517,2.122Z",
    transform: "translate(-1067.973 -691.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61970",
    "data-name": "Path 61970",
    d: "M1187.632,789.8l-1.421-.435a1.1,1.1,0,0,1,.641-2.1l1.422.432a1.1,1.1,0,1,1-.639,2.105Z",
    transform: "translate(-1053.216 -687.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61971",
    "data-name": "Path 61971",
    d: "M1168.385,783.242l-1.394-.515a1.092,1.092,0,0,1,.755-2.05l1.4.512a1.094,1.094,0,0,1-.754,2.055Z",
    transform: "translate(-1038.735 -682.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61972",
    "data-name": "Path 61972",
    d: "M1149.551,775.6l-1.363-.593a1.087,1.087,0,0,1,.865-1.993l1.364.59a1.088,1.088,0,0,1-.864,2Z",
    transform: "translate(-1024.569 -676.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61973",
    "data-name": "Path 61973",
    d: "M1131.182,766.91l-1.327-.67a1.081,1.081,0,0,1,.972-1.93l1.328.667a1.082,1.082,0,0,1-.971,1.935Z",
    transform: "translate(-1010.756 -670.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61974",
    "data-name": "Path 61974",
    d: "M1113.336,757.179l-1.286-.745a1.074,1.074,0,0,1,1.074-1.861l1.288.742a1.076,1.076,0,0,1-1.074,1.866Z",
    transform: "translate(-997.341 -662.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61975",
    "data-name": "Path 61975",
    d: "M1096.085,746.437l-1.24-.818a1.069,1.069,0,0,1,1.174-1.786l1.242.815a1.07,1.07,0,1,1-1.174,1.791Z",
    transform: "translate(-984.377 -654.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61976",
    "data-name": "Path 61976",
    d: "M1079.493,734.712l-1.19-.888a1.063,1.063,0,0,1,1.269-1.7l1.192.886a1.065,1.065,0,1,1-1.269,1.709Z",
    transform: "translate(-971.914 -645.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61977",
    "data-name": "Path 61977",
    d: "M1063.63,722.03l-1.135-.957a1.057,1.057,0,0,1,1.361-1.617l1.137.954a1.058,1.058,0,1,1-1.361,1.621Z",
    transform: "translate(-960.004 -636.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61978",
    "data-name": "Path 61978",
    d: "M1048.559,708.418l-1.075-1.024a1.051,1.051,0,0,1,1.448-1.523l1.077,1.022a1.053,1.053,0,1,1-1.449,1.527Z",
    transform: "translate(-948.695 -625.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61979",
    "data-name": "Path 61979",
    d: "M1034.348,693.9l-1.01-1.089a1.045,1.045,0,0,1,1.531-1.423l1.012,1.087a1.047,1.047,0,1,1-1.531,1.427Z",
    transform: "translate(-938.038 -614.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61980",
    "data-name": "Path 61980",
    d: "M1021.057,678.548l-.943-1.147a1.039,1.039,0,0,1,1.6-1.322l.946,1.145a1.041,1.041,0,1,1-1.6,1.326Z",
    transform: "translate(-928.073 -603.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61981",
    "data-name": "Path 61981",
    d: "M1008.615,662.5l-.885-1.193a1.033,1.033,0,0,1,1.658-1.232l.888,1.191a1.035,1.035,0,1,1-1.659,1.237Z",
    transform: "translate(-918.738 -591.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61982",
    "data-name": "Path 61982",
    d: "M996.916,645.909l-.835-1.229a1.027,1.027,0,0,1,1.7-1.156l.838,1.227a1.029,1.029,0,0,1-1.7,1.16Z",
    transform: "translate(-909.952 -578.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61983",
    "data-name": "Path 61983",
    d: "M985.836,628.913l-.794-1.255a1.021,1.021,0,0,1,1.725-1.094l.8,1.254a1.023,1.023,0,0,1-1.726,1.1Z",
    transform: "translate(-901.622 -565.827)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61984",
    "data-name": "Path 61984",
    d: "M975.234,611.628l-.763-1.273a1.015,1.015,0,0,1,1.74-1.046l.766,1.271a1.017,1.017,0,1,1-1.741,1.05Z",
    transform: "translate(-893.642 -552.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61985",
    "data-name": "Path 61985",
    d: "M964.966,594.158l-.745-1.286a1.009,1.009,0,0,1,1.745-1.013l.748,1.284a1.011,1.011,0,0,1-1.747,1.018Z",
    transform: "translate(-885.901 -539.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61986",
    "data-name": "Path 61986",
    d: "M954.9,576.6l-.734-1.293a1,1,0,0,1,1.731-.99l.743,1.288a1,1,0,0,1-1.737,1Z",
    transform: "translate(-878.303 -526.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61987",
    "data-name": "Path 61987",
    d: "M944.887,559.039l-.736-1.292a.979.979,0,0,1,1.7-.976l.746,1.286a.985.985,0,1,1-1.7.987Z",
    transform: "translate(-870.735 -513.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61988",
    "data-name": "Path 61988",
    d: "M934.758,541.554l-.749-1.283a.961.961,0,0,1,1.656-.975l.758,1.278a.966.966,0,0,1-1.662.987Z",
    transform: "translate(-863.067 -499.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61989",
    "data-name": "Path 61989",
    d: "M924.358,524.241l-.775-1.267a.943.943,0,0,1,1.606-.99l.784,1.262a.948.948,0,0,1-1.611,1Z",
    transform: "translate(-855.18 -486.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61990",
    "data-name": "Path 61990",
    d: "M913.524,507.218l-.811-1.244a.925.925,0,0,1,1.546-1.016l.82,1.238a.931.931,0,0,1-1.552,1.028Z",
    transform: "translate(-846.955 -473.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61991",
    "data-name": "Path 61991",
    d: "M902.132,490.572l-.856-1.214a.907.907,0,0,1,1.479-1.051l.865,1.208a.912.912,0,1,1-1.484,1.062Z",
    transform: "translate(-838.298 -461.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61992",
    "data-name": "Path 61992",
    d: "M890.073,474.411l-.909-1.175a.889.889,0,0,1,1.4-1.093l.917,1.169a.894.894,0,0,1-1.407,1.1Z",
    transform: "translate(-829.128 -449.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61993",
    "data-name": "Path 61993",
    d: "M877.24,458.868l-.969-1.126a.871.871,0,0,1,1.316-1.141l.977,1.118a.876.876,0,1,1-1.32,1.153Z",
    transform: "translate(-819.363 -437.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61994",
    "data-name": "Path 61994",
    d: "M863.534,444.1l-1.036-1.064a.853.853,0,0,1,1.218-1.195l1.044,1.056a.858.858,0,0,1-1.221,1.207Z",
    transform: "translate(-808.928 -426.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61995",
    "data-name": "Path 61995",
    d: "M848.872,430.3l-1.109-.987a.835.835,0,0,1,1.106-1.252l1.116.979a.84.84,0,1,1-1.108,1.264Z",
    transform: "translate(-797.762 -415.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61996",
    "data-name": "Path 61996",
    d: "M833.2,417.665l-1.186-.895a.817.817,0,0,1,.98-1.308l1.192.886a.822.822,0,1,1-.981,1.32Z",
    transform: "translate(-785.82 -406.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61997",
    "data-name": "Path 61997",
    d: "M816.492,406.436l-1.261-.785a.8.8,0,0,1,.84-1.36l1.267.776a.8.8,0,0,1-.84,1.372Z",
    transform: "translate(-773.098 -398.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61998",
    "data-name": "Path 61998",
    d: "M798.846,396.913l-1.334-.652a.768.768,0,0,1,.666-1.384l1.343.635a.777.777,0,1,1-.665,1.406Z",
    transform: "translate(-759.663 -390.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61999",
    "data-name": "Path 61999",
    d: "M780.22,389.474l-1.4-.494a.736.736,0,0,1,.48-1.391l1.407.476a.745.745,0,1,1-.477,1.412Z",
    transform: "translate(-745.488 -385.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62000",
    "data-name": "Path 62000",
    d: "M760.85,384.223l-1.448-.331a.7.7,0,0,1,.3-1.374l1.452.312a.713.713,0,1,1-.3,1.395Z",
    transform: "translate(-730.768 -381.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62001",
    "data-name": "Path 62001",
    d: "M740.992,381.234l-1.477-.162a.672.672,0,0,1,.137-1.336l1.479.142a.681.681,0,1,1-.131,1.357Z",
    transform: "translate(-715.697 -379.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62002",
    "data-name": "Path 62002",
    d: "M720.911,380.519l-1.485.019a.64.64,0,0,1-.025-1.279l1.485-.039a.649.649,0,0,1,.034,1.3Z",
    transform: "translate(-700.474 -379.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62003",
    "data-name": "Path 62003",
    d: "M700.913,381.892l-1.47.215a.608.608,0,0,1-.184-1.2l1.467-.234a.617.617,0,0,1,.195,1.219Z",
    transform: "translate(-685.334 -380.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62004",
    "data-name": "Path 62004",
    d: "M681.387,386l-1.422.426a.576.576,0,0,1-.338-1.1l1.416-.444a.585.585,0,0,1,.351,1.117Z",
    transform: "translate(-670.576 -383.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62005",
    "data-name": "Path 62005",
    d: "M662.82,393.031l-1.336.649a.544.544,0,0,1-.482-.975l1.327-.667a.553.553,0,1,1,.5.989Z",
    transform: "translate(-656.576 -388.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62006",
    "data-name": "Path 62006",
    d: "M645.812,403.112l-1.2.872a.512.512,0,0,1-.607-.824l1.191-.888a.521.521,0,1,1,.623.836Z",
    transform: "translate(-643.798 -396.567)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPagePhoto);
export default __webpack_public_path__ + "static/media/loginPagePhoto.e3002a480a02f539405c09784e6ef9ba.svg";
export { ForwardRef as ReactComponent };